module.exports = __webpack_public_path__ + "static/profile-e48a836963abf1502dfa64246deef589.jpg";